import type { GrantRules } from "@/shared/types";
import { GoogleUserProfile } from "@/shared/types";
import { create } from "zustand";

interface AuthStoreState {
  user: GoogleUserProfile | null;
  grant: GrantRules;
  isLoading: boolean;
  setUser: (user: GoogleUserProfile | null) => void;
  setGrant: (grant: GrantRules) => void;
  setLoading: (loading: boolean) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthStoreState>((set) => ({
  user: null,
  grant: {},
  isLoading: true,

  setUser: (user) => set({ user }),
  setGrant: (grant) => set({ grant }),
  setLoading: (isLoading) => set({ isLoading }),
  clearAuth: () => set({ user: null, grant: {}, isLoading: false }),
}));

